import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustMarquee } from "@/components/TrustMarquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Launch24 } from "@/components/Launch24";
import { Pricing } from "@/components/Pricing";
import { Compare } from "@/components/Compare";
import { Portfolio } from "@/components/Portfolio";
import { WhyFalkeen } from "@/components/WhyFalkeen";
import { Industries } from "@/components/Industries";
import { Process } from "@/components/Process";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Contact } from "@/components/Contact";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { PrivacyPage, TermsPage } from "@/pages/Legal";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <TrustMarquee />
      <About />
      <Services />
      <Launch24 />
      <Pricing />
      <Compare />
      <Portfolio />
      <WhyFalkeen />
      <Industries />
      <Process />
      <EnquiryForm />
      <Contact />
      <Faq />
      <FinalCta />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppFloat />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
